<template>
  <div class="didacticiel">

    <div class="grid-container content-page"> 
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-6 medium-offset-3 cell center">
          <bouton v-if="me" href="dashboard" class-bt="return">Retour au carnet de bord</bouton>
          <bouton v-else href="home" class-bt="return">Retour à l'accueil</bouton>
          <title-page attrpage="Globulo Quest" baseline="">Sondage</title-page>
        </div> 
        <div class="small-12 medium-8 medium-offset-2 cell ">  
          <div class="typeform-widget" :data-url="typeformUrl" style="width: 100%; height: 500px;"></div> 
        </div> 
      </div> 
    </div>    
  </div>    
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import { Carousel, Slide } from 'vue-carousel'
  import { mapState, mapActions } from 'vuex'

  
  export default {
    props: ['id'],
    components: { TitlePage, Bouton, Carousel, Slide },
    computed: {
      ...mapState(['me', 'unseenNotificationsCount']),
      typeformUrl() {
        let baseId = 'https://globuloquest.typeform.com'
        let formId = this.id
        let args = ""

        if (this.me) {
          args = `account_email=${this.me.email}&`
        }
        return `${baseId}/to/${formId}?${args}`
      }
    },
    methods: {
      ...mapActions(['checkForUnseenNotifications'])
    },
		mounted() {
      document.cookie = "completeAnonymousSurvey=true; expires=Fri, 31 Dec 9999 23:59:59 GMT";
      (function() { var qs,js,q,s,d=document, gi=d.getElementById, ce=d.createElement, gt=d.getElementsByTagName, id="typef_orm", b="https://embed.typeform.com/"; if(!gi.call(d,id)) { js=ce.call(d,"script"); js.id=id; js.src=b+"embed.js"; q=gt.call(d,"script")[0]; q.parentNode.insertBefore(js,q)}})()
		},
    async beforeRouteLeave(to, from, next) {
      if(this.me) {
        await this.checkForUnseenNotifications()
      }
      next()
    }
  }
</script>
